import TimerComponentMeta from './Timer';
import WatchValueComponentMeta from './WatchValue';
export default [WatchValueComponentMeta, TimerComponentMeta];